import React from 'react';
import '../../styles/HealthDistributionChart.css';

const HealthDistributionChart = ({ title, data }) => {
  const { total, healthy, monitor, intervention } = data;

  const getPct = (val) => (total > 0 ? Math.round((val / total) * 100) : 0);
  const healthyPct = getPct(healthy);
  const monitorPct = getPct(monitor);
  const interventionPct = getPct(intervention);

  const r = 40;
  const circ = 2 * Math.PI * r;
  
  const healthyDash = (healthyPct / 100) * circ;
  const monitorDash = (monitorPct / 100) * circ;
  const interventionDash = (interventionPct / 100) * circ;

  const healthyOffset = 0;
  const monitorOffset = -healthyDash;
  const interventionOffset = -(healthyDash + monitorDash);

  return (
    <div className="soil-health-card">
      <div className="sh-header">
        <h2>{title}</h2> 
        <span className="sh-subtitle">Latest field status</span>
      </div>
      
      <div className="sh-content">
        <div className="sh-chart-container">
          <svg viewBox="0 0 100 100" className="sh-donut">
            <circle cx="50" cy="50" r={r} className="donut-segment intervention" 
              strokeDasharray={`${interventionDash} ${circ}`} strokeDashoffset={interventionOffset} />
            <circle cx="50" cy="50" r={r} className="donut-segment monitor" 
              strokeDasharray={`${monitorDash} ${circ}`} strokeDashoffset={monitorOffset} />
            <circle cx="50" cy="50" r={r} className="donut-segment healthy" 
              strokeDasharray={`${healthyDash} ${circ}`} strokeDashoffset={healthyOffset} />
          </svg>
          <div className="sh-total">
            <h3>{total.toLocaleString()}</h3>
          </div>
        </div>

        <div className="sh-legend">
          <div className="sh-legend-item">
            <span className="dot healthy-dot"></span><span className="label">Healthy</span><span className="pct">{healthyPct}%</span>
          </div>
          <div className="sh-legend-item">
            <span className="dot monitor-dot"></span><span className="label">Monitor</span><span className="pct">{monitorPct}%</span>
          </div>
          <div className="sh-legend-item">
            <span className="dot intervention-dot"></span><span className="label">Intervention Required</span><span className="pct">{interventionPct}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthDistributionChart;